import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { EVENTS, ENDPOINTS } from './constants';
import constants from '@core/utils/constants';

// Listen for dish search requests
bus.on(EVENTS.DISH_SEARCH.REQUEST, async (payload) => {
  console.log('[DishSearchController] REQUEST event received:', payload);

  const store = getStore('dishSearch');
  if (!store) {
    console.error('[DishSearchController] dishSearch store not found');
    return;
  }

  // Emit loading event
  bus.emit(EVENTS.DISH_SEARCH.LOADING);

  try {
    const { searchQuery, filters = {}, page = 1 } = payload;
    const { categoryId, restaurantId, tags, sort, minPrice, maxPrice } = filters;

    // Build query parameters
    const params = new URLSearchParams();
    if (searchQuery) params.append('name', searchQuery);
    if (categoryId) params.append('categoryId', categoryId);
    if (restaurantId) params.append('restaurantId', restaurantId);
    
    // Some filters might not be supported natively by the search endpoint yet,
    // but we map the standard ones
    if (minPrice !== undefined) params.append('priceMin', minPrice.toString());
    if (maxPrice !== undefined) params.append('priceMax', maxPrice.toString());
    
    // Pagination (API expects limit & offset)
    const limit = 20;
    const offset = (page - 1) * limit;
    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    const url = `${ENDPOINTS.DISH_SEARCH}&${params.toString()}`;

    // Use network manager for API call
    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: `dish-search-${Date.now()}`,
      url,
      method: 'GET'
    });

    // Listen for response
    const dishSearchResponseHandler = (res) => {
      if (res.id.startsWith('dish-search-')) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, dishSearchResponseHandler);
        console.log('[DishSearchController] Response received:', res);

        if (res.success) {
          // API returns {statusCode: 200, data: [...], total: N}
          const responseData = res.data;
          const dishes = responseData?.data || responseData || [];
          const totalCount = responseData?.total || responseData?.count || res.count || (Array.isArray(dishes) ? dishes.length : 0);

          console.log('[DishSearchController] Parsed response:', { dishes, totalCount, responseData });

          bus.emit(EVENTS.DISH_SEARCH.LOADED, {
            dishes: Array.isArray(dishes) ? dishes : [],
            hasMore: dishes.length >= 20,
            page: page,
            totalCount: totalCount,
          });
        } else {
          bus.emit(EVENTS.DISH_SEARCH.ERROR, {
            message: res.data?.message || 'Erreur lors de la recherche',
          });
        }
      }
    };

    bus.on(constants.EVENTS.NETWORK.RESPONSE, dishSearchResponseHandler);

  } catch (error) {
    console.error('[DishSearchController] Error during search:', error);
    bus.emit(EVENTS.DISH_SEARCH.ERROR, error);
  }
});

// Listen for load more requests
bus.on(EVENTS.DISH_SEARCH.LOAD_MORE, async () => {
  console.log('[DishSearchController] LOAD_MORE event received');

  const store = getStore('dishSearch');
  if (!store) {
    console.error('[DishSearchController] dishSearch store not found');
    return;
  }

  const currentState = store.state;

  if (!currentState.hasMore || currentState.loading) {
    console.log('[DishSearchController] Cannot load more: hasMore=', currentState.hasMore, 'loading=', currentState.loading);
    return;
  }

  // Emit loading more event
  bus.emit(EVENTS.DISH_SEARCH.LOADING_MORE);

  try {
    const { searchQuery, filters = {}, page } = currentState;
    const { categoryId, restaurantId, tags, sort, minPrice, maxPrice } = filters;

    // Build query parameters - use the current page + 1 for next page
    const params = new URLSearchParams();
    const nextPage = page + 1;
    
    if (searchQuery) params.append('name', searchQuery);
    if (categoryId) params.append('categoryId', categoryId);
    if (restaurantId) params.append('restaurantId', restaurantId);
    
    if (minPrice !== undefined) params.append('priceMin', minPrice.toString());
    if (maxPrice !== undefined) params.append('priceMax', maxPrice.toString());
    
    // Pagination (API expects limit & offset)
    const limit = 20;
    const offset = (nextPage - 1) * limit;
    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    const url = `${ENDPOINTS.DISH_SEARCH}&${params.toString()}`;

    console.log('[DishSearchController] Loading more with page:', page + 1);

    // Use network manager for API call
    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: `dish-search-more-${Date.now()}`,
      url,
      method: 'GET'
    });

    // Listen for response
    const dishSearchMoreResponseHandler = (res) => {
      if (res.id.startsWith('dish-search-more-')) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, dishSearchMoreResponseHandler);
        console.log('[DishSearchController] Load more response received:', res);

        if (res.success) {
          // API returns {statusCode: 200, data: [...], total: N}
          const responseData = res.data;
          const dishes = responseData?.data || responseData || [];
          const totalCount = responseData?.total || responseData?.count || res.count || currentState.totalCount;

          console.log('[DishSearchController] Parsed load more response:', { dishes, totalCount });

          bus.emit(EVENTS.DISH_SEARCH.LOADED_MORE, {
            dishes: Array.isArray(dishes) ? dishes : [],
            hasMore: dishes.length >= 20,
            totalCount: totalCount,
            page: page + 1,
          });
        } else {
          bus.emit(EVENTS.DISH_SEARCH.ERROR, {
            message: res.data?.message || 'Erreur lors du chargement',
          });
        }
      }
    };

    bus.on(constants.EVENTS.NETWORK.RESPONSE, dishSearchMoreResponseHandler);

  } catch (error) {
    console.error('[DishSearchController] Error during load more:', error);
    bus.emit(EVENTS.DISH_SEARCH.ERROR, error);
  }
});

console.log('[DishSearchController] Controller loaded successfully');
